//  i am making my custom navbar because jaldhi submit krna hai and there are no mobile screens present yet so i am just making the navbar for the big screens baad me mobile ke liye develop krenge
import React from "react";

export default function Navbar() {
  return (
    <div className="navbar_wrapper">
      <div className="nav_left">
        <div className="nav_items">Home</div>
        <div className="nav_items">Order</div>
        <div className="nav_items">Menu</div>
        <div className="nav_items">Contact Us</div>
      </div>
      <div className="nav_right">
        <div className="nav_items">
          {" "}
          Menu <img src="images/icons/hamburger.png" />
        </div>
      </div>
    </div>
  );
}
